import ResponsiveModal from "@/modules/common/components/ui-kit/modals/responsive-modal";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import { Box, TextField, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import EditIcon from "@/assets/icons/lead-page/edit-icon";
import FieldWrapper from "@/modules/lead-page/new/components/sidebar/fields/field-wrapper";
import { useState } from "react";

const EditName = ({
  name,
  isLoading,
  isError,
  handleConfirmUpdate,
}: {
  name?: string;
  isLoading?: boolean;
  isError?: boolean;
  handleConfirmUpdate: (name?: string) => void;
}) => {
  const screen = useScreenSize();
  const theme = useTheme();

  const [modalOpen, setModalOpen] = useState(false);

  const [value, setValue] = useState<string | null>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  return (
    <>
      <Box
        sx={{
          display: "inline-flex",
          gap: "12px",
          alignItems: "flex-start",
          cursor: "pointer",
          position: "relative",
          minWidth: 0,
          "&:hover .edit-icon": {
            opacity: 1,
          },
        }}
        onClick={() => setModalOpen(true)}
      >
        <Typography
          sx={{
            ...theme.nawy.typography.english.variants.headline.sm,
            color: name?.trim()
              ? theme.nawy.colors.semantic.text.primary
              : theme.nawy.colors.semantic.text.tertiary,
            "&:hover": {
              textDecoration: "underline",
              cursor: "pointer",
            },
            flex: 1,
            wordBreak: "break-word",
            overflowWrap: "break-word",
            hyphens: "auto",
            maxWidth: "100%",
            minWidth: 0,
          }}
        >
          {name?.trim() ? name : "No Name"}
        </Typography>

        <Box
          className="edit-icon"
          sx={{
            color: theme.nawy.colors.semantic.text.accent,
            opacity: screen.isMobile ? 1 : 0,
            transition: "opacity 0.2s ease-in-out",
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            minHeight: theme.nawy.spacing.lg,
          }}
        >
          <EditIcon />
        </Box>
      </Box>

      {modalOpen && (
        <ResponsiveModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          title="Edit name"
          confirmButtonText="Save"
          cancelButtonText="Cancel"
          onConfirm={() => {
            handleConfirmUpdate(value ?? undefined);
            setValue(null);
          }}
          isLoading={isLoading}
          isConfirmDisabled={!value}
          snapPoints={[1]}
        >
          <FieldWrapper
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <TextField
              sx={{
                width: "100%",
                borderRadius: theme.nawy.spacing.md,
              }}
              error={isError}
              onChange={handleChange}
              label={"Name"}
              size="small"
              defaultValue={name || ""}
            />
          </FieldWrapper>
        </ResponsiveModal>
      )}
    </>
  );
};

export default EditName;
